import React, { useEffect } from 'react';
import { Box, Typography,  useTheme, useMediaQuery } from '@mui/material';
//import { logout } from '../../../auth/logout';
import imagen from '../../assets/img/konecta.jpg';

const ExternalAuthorization = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const timer = setTimeout(() => {
          //logout();
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Box 
          display="flex" 
          flexDirection="column"
          justifyContent="center" 
          alignItems="center" 
          height="100vh"
          padding="1rem"
          bgcolor="#FFFFFF"
        >
          <img src={imagen} alt="Illustration" style={{ maxWidth: '100%', height: 'auto', width: isMobile ? '100%' : '300px' }} />
          <Typography variant="h5" color="textPrimary">
            Acceso Denegado
          </Typography>
        </Box>
      );
};

export default ExternalAuthorization;